import * as React from 'react'

function SvgSendLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 200 200"
      {...props}
    >
      <g fillRule="evenodd" clipPath="url(#clip0_404_51464)" clipRule="evenodd">
        <path
          fill="#F0FFF9"
          d="M31.275 94C33.762 71.5 52.837 54 76 54s42.238 17.5 44.725 40H125c14.359 0 26 11.641 26 26s-11.641 26-26 26H26c-14.36 0-26-11.641-26-26s11.64-26 26-26h5.275z"
        ></path>
        <path
          fill="#00D37E"
          d="M145.473 39.095l.983-.371 5.081-1.914 2.187-.824c1.599-.603 3.168.946 2.586 2.552l-.796 2.198-1.849 5.105-.358.988-41.508 114.596-1.374 3.793-2.221 6.131-.43 1.187c-.683 1.885-3.405 1.705-3.834-.253l-.27-1.233-1.396-6.37-.863-3.941-12.083-55.167a2 2 0 00-1.55-1.531L32.002 92.533l-3.94-.813-6.385-1.317-1.238-.255c-1.963-.405-2.176-3.124-.301-3.83l1.183-.447 6.1-2.298 3.765-1.418 114.287-43.06zm-12.536 15.409L49.513 85.936 89.8 94.247c1.287.266 2.497.735 3.596 1.372l39.542-41.115zm-34.34 47.247c.206.542.373 1.104.5 1.681l8.694 39.695 29.596-81.709-38.79 40.333z"
        ></path>
        <path
          fill="#F0FFF9"
          d="M141.001 159.584A10.884 10.884 0 01151 153c4.483 0 8.333 2.712 9.999 6.584A7.683 7.683 0 01167 167.08a7.68 7.68 0 01-7.68 7.68h-16.64a7.68 7.68 0 01-7.68-7.68 7.683 7.683 0 016.001-7.496zM19.001 44.584A10.883 10.883 0 0129 38c4.483 0 8.333 2.712 9.999 6.584A7.68 7.68 0 0137.32 59.76H20.68a7.68 7.68 0 01-1.679-15.176zM159.001 50.584A10.883 10.883 0 01169 44c4.483 0 8.333 2.712 9.999 6.584a7.68 7.68 0 01-1.679 15.176h-16.64a7.68 7.68 0 01-1.679-15.176z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_404_51464">
          <path fill="#fff" d="M0 0H200V200H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgSendLogo
